import {MarkerType} from "reactflow";
import {HugeiconsIcon} from "@hugeicons/react";
import {
  CornerDownRightIcon,
  FormIcon,
  Target02Icon,
} from "@hugeicons/core-free-icons";
import {NodeType, NodeTypeIcon} from "../model/ModelData";

// Zaednicki props za site ikoni vo jazlite. Nema fiksna boja (color="currentColor"),
// pa ikonata ja zema bojata od iconChipSx / ListItemIcon (accent bojata na jazolot).
const ICON_PROPS = {size: 12, strokeWidth: 1.5, color: "currentColor"};

export const mapNode = ({node, nodes, intents = []}) => {
  let edgeItems = [];
  let steps = [];
  const routes = getRoutes(node.routes);

  for (const route of routes) {
    if (route === null) {
      continue;
    }
    if (route?.target) {
      edgeItems.push({
        id: `${node?.id}_${route?.target}_${route?.id}`,
        source: node?.id,
        sourceHandle: route?.id,
        target: route?.target,
        type: 'smoothstep',
        data: {selectIndex: 0},
        markerEnd: {type: MarkerType.Arrow},
      });
    }
    let secondary = route?.data?.value || route?.type?.toLowerCase();
    if (route?.type?.toLowerCase() === "intent") {
      const intent = intents?.find(i => i?.id === route?.data?.intent_id);
      if (intent?.name) {
        secondary = intent?.name;
      }
    }
    steps.push({
      icon: route?.type?.toLowerCase() === "intent"
          ? <HugeiconsIcon icon={Target02Icon} {...ICON_PROPS}/>
          : <HugeiconsIcon icon={CornerDownRightIcon} {...ICON_PROPS}/>,
      text: `${route?.name?.toLowerCase() || ""}`,
      secondary: secondary,
      id: route?.id,
      type: route?.type,
    });
  }

  const iconComponent = getIcon(node?.type);

  const newNode = {
    id: node?.id,
    type: getNodeBlockType(node.type),
    text: {},
    position: {x: node?.coords?.x || 0, y: node?.coords?.y || 0},
    data: {
      greet: node?.data?.greet[0] || "",
      icon: iconComponent,
      name: node?.type === NodeType?.CALL_TRANSFER ? `${node?.data?.transfer_number || "number missing"}` : node.name,
      steps: steps,
      node: node
    }
  };

  return {newNode, edgeItems};
};

const getNodeBlockType = (type) => {
  let blockType;
  switch (type) {
    case NodeType.START:
      blockType = "start";
      break;
    case NodeType.END:
      blockType = "end";
      break;
    case NodeType.START_FLOW:
      blockType = "custom";
      break;
    case NodeType.CALL_TRANSFER:
      blockType = "transfer_call";
      break;
    default:
      blockType = "custom";
  }
  return blockType;
}

export const mapStartFormToNode = ({node, nodes}) => {
  let edgeItems = [];
  let steps = [];
  // const routes = getRoutes(node.routes);
  const formNodes = nodes?.filter(n => n?.data?.form_id === node?.data?.form_id);

  mapStartFormSteps(node, formNodes, nodes, edgeItems, steps);

  const newNode = {
    id: node?.id,
    type: 'form',
    text: {},
    position: {x: node?.coords?.x || 0, y: node?.coords?.y || 0},
    data: {
      greet: node?.data?.greet[0] || "",
      icon: <HugeiconsIcon icon={FormIcon} {...ICON_PROPS} size={13}/>,
      name: node.name,
      steps: steps,
      node: node,
      isConnected: edgeItems.length > 0
    },
  }
  return {newNode, edgeItems};
}


const mapStartFormSteps = (node, formNodes, nodes, edges = [], steps = []) => {
  let icon = getIcon(node?.type);
  const step = {
    icon: icon,
    text: node?.data.greet[0] || node?.name || "",
    type: node?.type,
    id: node?.id
  };

  steps.push(step);

  const nextNodeId = node?.routes?.static?.next?.target;
  let next = formNodes?.find(i => i?.id === nextNodeId);
  if (next) {
    mapStartFormSteps(next, formNodes, nodes, edges, steps);
  } else {
    next = nodes.find(i => i?.id === nextNodeId);
    const startNode = nodes?.find(i => i?.data?.form_id === node?.data?.form_id && i?.type === NodeType.START_FORM);
    if (next) {
      edges.push({
        id: `${node?.id}_${next?.id}`,
        source: startNode?.id,
        sourceHandle: node?.id,
        target: next?.id,
        type: 'smoothstep',
        data: {
          selectIndex: 0,
        },
        markerEnd: {
          type: MarkerType.Arrow,
        },
      })
    }
  }
  return {steps, edges};
}

export const getRoutes = (routes) => {
  let newRoutes = routes?.dynamic ? routes?.dynamic?.map(route => ({...route, variant: "dynamic"})) : [];
  if (routes?.static) {
    for (const key of Object.keys(routes.static).sort()) {
      const item = routes.static[key] ? {...routes.static[key]} : {};
      item.type = key;
      item.id = item?.id || key;
      item.variant = "static"
      newRoutes.unshift(item);
    }
  }
  return newRoutes;
}

const getIcon = (type) => {
  const Icon = NodeTypeIcon[type] || NodeTypeIcon.text;
  return <Icon {...ICON_PROPS}/>;
}